import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "shared/model/useFetch";
import useAlertModalAtom from "shared/model/useAlertModalAtom";

const usePutMyStore = (nameRef, addressRef, imgUrlRef) => {
  const navigate = useNavigate();
  const [fetchResult, fetchRequest] = useFetch();
  const [, setAlert] = useAlertModalAtom();

  const request = () => {
    fetchRequest("PUT", `/admin/store/my`, {
      store_name: nameRef?.current?.value,
      address: addressRef?.current?.value,
      logo_img: imgUrlRef?.current,
    });
  };

  useEffect(() => {
    switch (fetchResult?.statusCode) {
      case 200:
        navigate("/store/my");
        break;
      case 400:
        if (fetchResult?.data?.error_code === "store_name")
          setAlert("매장 이름을 확인해 주세요.");
        else if (fetchResult?.data?.error_code === "address")
          setAlert("매장 주소를 확인해 주세요.");
        else setAlert("입력한 값의 형식이 잘못되었습니다.");
        break;
    }
  }, [fetchResult]);

  return [request];
};

export default usePutMyStore;
